import { Div } from "components/Base";
import React from "react";

const CONTAINER_STYLE = {
  width: "100%",
  height: "100%",
  paddingBottom: "15px",
  justifyContent: "flex-start",
  paddingLeft: "10px"
};

const INPUT_STYLE = {
  paddingRight: "10px",
  textAlign: "center",
  fontSize: "25px",
  width: "calc(100% - 44px)",
  borderTop: 0,
  borderLeft: 0,
  borderRight: 0,
  borderBottom: "1px solid #c9d7f6",
  background: "none",
  fontFamily: '"Noto Serif", cursive',
  fontStyle: "italic",
  fontWeight: 300,
  color: "black"
};

const SignatureType = ({
  typingRef,
  handleTyping,
  typedSignature,
  onTypeEnd,
  readOnly = false
}) => (
  <Div display="row.center.flex-end" style={CONTAINER_STYLE}>
    <input
      aria-label="Signature input"
      autoFocus
      value={typedSignature}
      style={{ ...INPUT_STYLE, ...{ borderBottomWidth: readOnly ? 0 : 1 } }}
      type="text"
      ref={typingRef}
      onKeyUp={onTypeEnd}
      onChange={({ target: { value } }) => handleTyping(value)}
    />
  </Div>
);

export default SignatureType;
